import { useIntersectionObserver } from "@2u-landing-pages/utils";
import EventClient from "@2u-landing-pages/utils/event-client";
import { Button as ButtonV1, IconFeatherChevronDown, IconFeatherChevronUp, Select } from "@red-digital/bricks";
import React, { useCallback, useRef, useState } from "react";
import { filterKeyMap } from "../../filterAndSort";
import { FilterCfg, FilterLabels } from "../../FilterBar.types";

// @ts-ignore
import styles from "../../FilterBar.module.scss";

type ProgramFilterProps = {
  filters: any;
  setFilters: Function;
  numResults: number;
  filterLabels?: FilterLabels;
  selectFilterGroupOptions?: FilterCfg;
  useButtons?: boolean;
  btnsFilterGroups?: FilterCfg;
};

const SelectIcon = ({ className = "" }: { className?: string }) => {
  if (className === "b-select__toggle--open") {
    return <IconFeatherChevronUp />
  }

  return <IconFeatherChevronDown />
};

export const InlineFilter: React.FC<ProgramFilterProps> = ({
  filters,
  setFilters,
  numResults,
  filterLabels,
  selectFilterGroupOptions,
  useButtons,
  btnsFilterGroups
}) => {
  const filterGroups = useButtons ? btnsFilterGroups : selectFilterGroupOptions;
  const [selectKey, setSelectKey] = useState(0);
  const numResultsRef = useRef(numResults);

  const handleResetFilters = () => {
    setFilters({});
    setSelectKey(prev => prev + 1);

    EventClient.elementClicked({
      webElement: {
        elementType: "Landing Page",
        htmlId: "",
        location: "Select Filter",
        name: "Reset filters",
        position: "Select Filter",
        text: "Reset filters",
      },
    });
  };

  const handleIntersect = useCallback(() => {
    EventClient.elementViewed({
      webElement: {
        elementType: "Landing Page",
        htmlId: String(numResultsRef.current),
        location: "Gallery",
        position: "Gallery",
        text: String(numResultsRef.current),
      },
    });
  }, [numResultsRef]);

  const addObserver = useIntersectionObserver(handleIntersect, { threshold: 0.5 });
  const setObserver = useCallback(
    (element: HTMLElement | null) => {
      if (element) addObserver(element);
    },
    [addObserver]
  );

  return (
    <>
      { filterGroups && (
      <div className={styles.gallerySelectFiltersContainer}>
        <div className={styles.gallerySelectFilters}>
          {Object.keys(filterGroups).map((group) => (
            filterGroups[group]?.length > 0 && (
            <div
              key={`${group}-${selectKey}-${filterGroups[group]?.length}-container`}
              className={styles.gallerySelectFilterGroup}
            >
              <label>{filterLabels?.[filterKeyMap[group as keyof typeof filterKeyMap]] || group}</label>
              <Select
                placeholder=" - Select - "
                key={`${group}-${selectKey}-${filterGroups[group]?.length}`}
                className={styles.galleryFilterSelect}
                value={filters[filterKeyMap[group as keyof typeof filterKeyMap]]?.[0] || ""}
                arrow={SelectIcon}
                options={filterGroups[group]?.map((option: any) => ({
                  label: option.name,
                  value: option.value,
                }))}
                onSelect={(option) => {
                  const key = filterKeyMap[group as keyof typeof filterKeyMap];
                  const value = option.value;

                  setFilters({
                    ...filters,
                    [key]: value ? [value] : null,
                  });

                  EventClient.elementClicked({
                    webElement: {
                      elementType: group,
                      htmlId: "select",
                      location: "Inline Filter",
                      name: option.value,
                      position: group,
                      text: option.value,
                    },
                  });
                }}
              />
            </div>
            )
          ))}
          <ButtonV1 className={styles.galleryFiltersReset} onClick={handleResetFilters} size="medium">
            Reset filters
          </ButtonV1>
        </div>
        <div className={styles.galleryFilterTotal} ref={setObserver}>
          <span>
            {numResults} Result{numResults === 1 ? "" : "s"}
            </span>
          </div>
        </div>
      )}
    </>
  );
};
